import { ELUVE_FHIR_NAMESPACE } from '@eluve/plan-shapes';

/**
 * The clinical-task-OWNED FHIR system URIs, browser/backend shared. Mirrors
 * the backend's `buildIdentifierSystem('clinical-task')` (this lib can't
 * import the nestjs-medplum helper) — same seam as plan-shapes'
 * CARE_PLAN_GENERATION_JOB_IDENTIFIER_SYSTEM; equality is pinned by a spec in
 * the backend mini-apps lib. Cross-agent markers (review-status,
 * derived-from-appointment, …) are NOT minted here — they belong to the
 * mini-app framework, not to this agent.
 */

/**
 * Identifier system for a Clinical Task's own uuid
 * (`https://eluve.com/clinical-task-id|<uuid>`). Deliberately DISJOINT from
 * the care-plan-generation-job Task identifier system, so the clinician-facing
 * Clinical Task population and the job-state Task population never match each
 * other's queries (ENG-5218).
 */
export const CLINICAL_TASK_ID_SYSTEM = `${ELUVE_FHIR_NAMESPACE}/clinical-task-id`;

/** Task.code coding system carrying the flat category enum. Also what keeps
 *  Clinical Tasks recognisable next to other Task producers' codes. */
export const CLINICAL_TASK_CATEGORY_SYSTEM = `${ELUVE_FHIR_NAMESPACE}/clinical-task-category`;

/**
 * Identifier system for the job-state Task mirroring the async extraction run
 * (`https://eluve.com/clinical-task-extraction-job-id|<appointmentId>`):
 * `in-progress` while the agent runs, `completed`/`failed` when it settles.
 * The frontend's observable in-flight signal — same pattern as care plans'
 * CARE_PLAN_GENERATION_JOB_IDENTIFIER_SYSTEM. Mirrors the backend's
 * `buildIdentifierSystem('clinical-task-extraction-job')`; disjoint from
 * CLINICAL_TASK_ID_SYSTEM so the marker never matches task-list queries.
 */
export const CLINICAL_TASK_EXTRACTION_JOB_SYSTEM = `${ELUVE_FHIR_NAMESPACE}/clinical-task-extraction-job-id`;
